import type { FormEvent } from 'react'

export const stopEvent =
  <_T>(run?: (e?: FormEvent) => unknown) =>
  (e?: FormEvent) => {
    e?.preventDefault?.()
    e?.stopPropagation?.()
    if (run) {
      return run(e)
    }
    return undefined
  }
